import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2787ef07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "actions-data" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("  Favoritar")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  Desfavoritar")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  Editar")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  Excluir")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Sem dados ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarOutlined = _resolveComponent("StarOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_StarFilled = _resolveComponent("StarFilled")!
  const _component_FormOutlined = _resolveComponent("FormOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_MoreOutlined = _resolveComponent("MoreOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return ( _ctx.listSchedules.length > 0)
    ? (_openBlock(), _createBlock(_component_a_table, {
        key: 0,
        size: "small",
        columns: _ctx.columns,
        dataSource: _ctx.listSchedules,
        rowKey: (record) => record.id,
        rowSelection: {onChange: (selectedRowKeys, selectedRows) => {
            _ctx.onSelectTableChange(selectedRowKeys, selectedRows)
        }},
        pagination: {defaultPageSize: 6},
        class: "datatable"
      }, _createSlots({ _: 2 }, [
        (_ctx.showActions)
          ? {
              name: "action",
              fn: _withCtx(({ record }) => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_a_dropdown, {
                    placement: "topLeft",
                    trigger: ['click']
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, { class: "teste" }, {
                        default: _withCtx(() => [
                          (!_ctx.favorites)
                            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: "0",
                                onClick: ($event: any) => (_ctx.setFavorite(record))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_StarOutlined),
                                    _hoisted_2
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.favorites)
                            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: "0",
                                onClick: ($event: any) => (_ctx.removeFavorite(record))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_StarFilled),
                                    _hoisted_3
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_menu_item, {
                            key: "1",
                            onClick: ($event: any) => (_ctx.editSchedule(record))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _createVNode(_component_FormOutlined),
                                _hoisted_4
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          (!_ctx.favorites)
                            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: "2",
                                onClick: ($event: any) => (_ctx.deleteSchedule(record))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_DeleteOutlined),
                                    _hoisted_5
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "btn-more-schedules",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_MoreOutlined)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["columns", "dataSource", "rowKey", "rowSelection"]))
    : (_openBlock(), _createBlock(_component_a_empty, {
        key: 1,
        style: {"margin-top":"20px"}
      }, {
        description: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }))
}